module.exports = __webpack_public_path__ + "img/system-research-logo-color.93ba09c7.png";